import { IS_LOADING, IS_SAVING } from "../constants.js";
import {
	REDUCER_NAME,
	CONTRACT_DATA,
	CONTRACT_FORM_DATA,
} from "./constants.js";

export const state = {
	[REDUCER_NAME]: {
		[IS_LOADING]: false,
		[IS_SAVING]: false,
		[CONTRACT_DATA]: {
			contract_id: null,
			revision: null,
			title: null,
			content: null,
			customer_unique_id: null,
			owner_name: null,
			owner_email: null,
			owner_phone: null,
			agent_name: null,
			agent_address: null,
			proceeds_to: null,
			mailing_address: null,
			pickup_address: null,
			provenance: null,
			ss1a: 1,
			ss1b: 999,
			ss1c: 30.0,
			ss2a: 1000,
			ss2b: 1001,
			ss2c: 20.0,
			ss3a: 1002,
			ss3c: 20.0,
			returned_flat_fee: null,
			returned_percentage: null,
			signed_by: null,
			signed_by_name: null,
			signed_date: null,
			signed_remote_addr: null,
			signed_http_x_forwarded_for: null,
			customer_signature: null,
			customer_signature_date: null,
			customer_signature_remote_addr: null,
			customer_signature_http_x_forwarded_for: null,
			valid: "y",
			effective_date: null,
			expiration_date: null,
			created_by: null,
			creation: null,
			token: null,
			sent_customer_email_unixtime: null,
			cataloguing_complete: "n",
			heard_about: null,
			referrer: null,
			pickup: null,
		},
		[CONTRACT_FORM_DATA]: {
			email: null,
			signature: null,
		},
	},
};
